var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReviewAnalysis(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66699 18.3346V3.33464C1.66699 2.8763 1.83033 2.48408 2.15699 2.15797C2.48366 1.83186 2.87588 1.66852 3.33366 1.66797H16.667C17.1253 1.66797 17.5178 1.8313 17.8445 2.15797C18.1712 2.48464 18.3342 2.87686 18.3337 3.33464V13.3346C18.3337 13.793 18.1706 14.1855 17.8445 14.5121C17.5184 14.8388 17.1259 15.0019 16.667 15.0013H5.00033L1.66699 18.3346ZM7.56283 11.8763L10.0003 10.3971L12.4378 11.8763L11.792 9.10547L13.9587 7.23047L11.1045 7.0013L10.0003 4.3763L8.89616 7.0013L6.04199 7.23047L8.20866 9.10547L7.56283 11.8763Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewAnalysis);
export default __webpack_public_path__ + "static/media/Review-Analysis.04c4b31813a4193b02412260c11841dd.svg";
export { ForwardRef as ReactComponent };